module.exports = __webpack_public_path__ + "img/cc.554ddaf2.png";